import { formatToDollar, formatToPercent } from "@inrev/common";
import { type Decision } from "@portal/api/decisioning";

type TermsInput = Pick<Decision, "rate" | "singleLimit" | "aggregateLimit">;

const CENTS_FORMATTER = new Intl.NumberFormat("en", {
	minimumFractionDigits: 2,
	maximumFractionDigits: 2,
});

/** "$250,000" for whole dollars, "$1.50" when there are cents. */
export const formatLimit = (amount: number): string =>
	Number.isInteger(amount)
		? `${formatToDollar(amount, { round: true })}`
		: `$${CENTS_FORMATTER.format(amount)}`;

/** ["2% rate", "$250,000 single", "$500,000 aggregate"]; empty unless the decision is an approval with terms. */
export const decisionTermParts = ({ rate, singleLimit, aggregateLimit }: TermsInput): string[] => {
	if (rate === null || singleLimit === null || aggregateLimit === null) return [];
	return [
		`${formatToPercent(rate)} rate`,
		`${formatLimit(singleLimit)} single`,
		`${formatLimit(aggregateLimit)} aggregate`,
	];
};
